var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 7.20001H8.39995C7.73721 7.20001 7.19995 7.73727 7.19995 8.40001V13.8C7.19995 14.4628 7.73721 15 8.39995 15H13.8C14.4627 15 15 14.4628 15 13.8V8.40001C15 7.73727 14.4627 7.20001 13.8 7.20001Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 10.8H4.2C3.88174 10.8 3.57652 10.6736 3.35147 10.4485C3.12643 10.2235 3 9.91826 3 9.6V4.2C3 3.88174 3.12643 3.57652 3.35147 3.35147C3.57652 3.12643 3.88174 3 4.2 3H9.6C9.91826 3 10.2235 3.12643 10.4485 3.35147C10.6736 3.57652 10.8 3.88174 10.8 4.2V4.8",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy.a6be481a37d1b55e5be7b513b9752250.svg";